import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import api2 from "../../../Component/axios_Interceptor/api2";
import url, { SERVER_ADDRESS } from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import {
  CenterView,
  CheckBox,
  Icon,
  RowView,
  RowView2,
  TitleArea,
} from "../../../Component/style/common_style";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import Calendar from "./Component/Calendar";
import CoinPaymentModal from "./Modal/CoinPaymentModal";

const LiveMake = () => {
  const Navigate = useNavigate();

  const timeList = new Array(24).fill("");
  const countList = new Array(20).fill("");

  const [livedate, setLivedate] = useState<string>("");
  const [livetime, setLivetime] = useState<number[]>([]);
  const [live_limit, setLive_limit] = useState(0);
  const [live_title, setLive_title] = useState("");
  const [live_img, setLive_img] = useState<string>("");
  const [picPreview, setPicPreview] = useState("");
  const [secret_yn, setSecret_yn] = useState(false);
  const handleSecret_yn = () => {
    setSecret_yn(!secret_yn);
  };

  const [unavailableTime, setUnavailableTime] = useState<number[]>([]);

  const unavailable_time_check = async () => {
    try {
      const res = await api.get(url.Communication_url.unavailable_time, {
        params: { select_date: livedate, userid: "seller1" },
      });
      const data = res.data;
      console.log(data);
      const result = data.flatMap((item: any) => {
        if (item.end === `${livedate} 00:00:00`) {
          return [];
        }
        const startHour = new Date(item.start).getHours();
        const endHour = new Date(item.end).getHours();
        return getTimeArr(startHour, endHour);
      });
      setUnavailableTime(result);
    } catch (error) {
      console.error("실패:", error);
    }
  };

  const getTimeArr = (start: number, end: number) => {
    const range = [];
    // 끝 시간이 0인 경우  start부터 23까지
    const actualEnd = end === 0 ? 23 : end - 1;
    for (let i = start; i <= actualEnd; i++) {
      range.push(i);
    }
    return range;
  };

  useEffect(() => {
    if (livedate !== "") {
      unavailable_time_check();
    }
  }, [livedate]);

  useEffect(() => {}, []);

  const setting_livetime = (time: number) => {
    if (isUnableTime(time) && !livetime.includes(time)) {
      return;
    }
    let copyArr = [...livetime];
    // 배열 삭제
    if (livetime[0] === time) {
      const delArr = copyArr.filter((num) => num !== time);
      setLivetime(delArr);
      return;
    }
    if (livetime.includes(time)) {
      const delArr = copyArr.filter((num) => num < time);
      setLivetime(delArr);
      return;
    }
    // 배열 등록
    if (livetime.length > 0 && time > livetime[livetime.length - 1]) {
      const lastNum = livetime[livetime.length - 1];
      for (let i = lastNum + 1; i <= time; i++) {
        copyArr.push(i);
      }
      copyArr.sort((a, b) => a - b);
      setLivetime(copyArr);
      return;
    }
    if (livetime.length > 0 && livetime[0] - 1 !== time) {
      for (let i = time; i < livetime[0]; i++) {
        copyArr.push(i);
      }
      copyArr.sort((a, b) => a - b);
      setLivetime(copyArr);
      return;
    }
    copyArr = [...livetime, time];
    copyArr.sort((a, b) => a - b);
    setLivetime(copyArr);
  };
  const setting_title = (e: React.ChangeEvent<HTMLInputElement>) =>
    setLive_title(e.target.value);

  const picPreviewRef = useRef<HTMLInputElement | null>(null);
  const insert_pic = () => {
    if (picPreviewRef && picPreviewRef.current) {
      picPreviewRef.current.click();
    }
  };
  const allowedExtensions = [".png", ".jpg", ".jpeg"];
  const renderPic = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const fileExtension = file.name.toLowerCase();

      if (!allowedExtensions.some((ext) => fileExtension.endsWith(ext))) {
        alert("png, jpg, jpge 파일만 첨부가능합니다.");
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target && typeof e.target.result === "string") {
          setting_pic(file);
        }
      };
      reader.readAsDataURL(file);
    }
  };
  const setting_pic = async (file: File) => {
    try {
      const res = await api.post(
        url.Communication_url.upload_live_img,
        { file: file },
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.message.includes("성공")) {
        setLive_img(res.data.file_path);
        setPicPreview(res.data.file_path);
      }
    } catch (error) {
      console.error("실패:", error);
    }
  };

  // 이모지 체크
  // const emojiRegex = /[\p{Emoji_Presentation}\u200d]+/gu;
  const emojiRegex =
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u26FF]|\uFE0F)/g;

  // 라이브 예약 체크
  const create_live_API = async () => {
    if (livetime.length === 0 || live_title === "" || live_img === "") {
      return;
    }
    if (emojiRegex.test(live_title)) {
      alert("제목에 이모지는 사용할 수 없습니다.");
      return;
    }

    handleModal();
  };

  // 결제 모달
  const [visible, setVisible] = useState(false);
  const handleModal = () => {
    setVisible(!visible);
  };

  const make_date = (
    date: string,
    time: number[],
    type: "start" | "finish"
  ) => {
    const getTimeHour = (hour: number) => (hour >= 10 ? hour : `0${hour}`);

    let timeDate = new Date(date);
    let timeHour = getTimeHour(
      type === "start" ? time[0] : time[time.length - 1] + 1
    );
    if (timeHour === 24) {
      timeDate.setDate(timeDate.getDate() + 1);
      timeHour = "00";
    }
    const formattedDate = timeDate.toISOString().split("T")[0];
    return `${formattedDate} ${timeHour}:00:00`;
  };

  // 못쓰는 시간 체크
  const current_date = moment(new Date()).format("YYYY-MM-DD");
  const current_hours = new Date().getHours();

  const isUnableTime = (idx: number) => {
    if (current_date === livedate && current_hours + 1 > idx) {
      return true;
    }
    if (unavailableTime.length === 0) {
      return false;
    }
    return unavailableTime.includes(idx);
  };

  return (
    <Layout_Admin menuname={"라이브 목록"}>
      <TitleArea>
        <div>라이브 만들기</div>
      </TitleArea>

      <InsertArea className="top">
        <Calendar
          livedate={livedate}
          setLivedate={setLivedate}
          setLivetime={setLivetime}
        />
        {livedate && (
          <>
            <div className="box">
              <div>시간 설정</div>
              <ScrollBox>
                {timeList.map((_, idx) => {
                  const hour = idx < 10 ? `0${idx}` : idx;
                  const ampm = idx < 12 ? "오전" : "오후";

                  return (
                    <ClickBox
                      className={
                        livetime.includes(idx)
                          ? "this"
                          : isUnableTime(idx)
                          ? "unable"
                          : ""
                      }
                      key={idx}
                      onClick={() => setting_livetime(idx)}
                    >{`${ampm} ${hour}:00`}</ClickBox>
                  );
                })}
              </ScrollBox>
            </div>

            <div className="box">
              <div>수용 인원</div>
              <ScrollBox>
                {countList.map((_, idx) => {
                  const countnum = 50 * (idx + 1);

                  return (
                    <ClickBox
                      className={live_limit === countnum ? "this" : ""}
                      key={idx}
                      onClick={() => setLive_limit(countnum)}
                    >{`${countnum}명`}</ClickBox>
                  );
                })}
              </ScrollBox>
            </div>
          </>
        )}

        {livetime && live_limit !== 0 && (
          <>
            <div style={{ flex: 0.7, width: "100%" }}>
              <div>라이브 제목</div>
              <InputBox
                value={live_title}
                onChange={setting_title}
                placeholder="라이브 제목을 입력해주세요."
              />

              <div>썸네일 이미지</div>
              <PicBox onClick={insert_pic}>
                {picPreview ? (
                  <Icon src={SERVER_ADDRESS + "openfile/" + picPreview} />
                ) : (
                  <div>+</div>
                )}
              </PicBox>

              <RowView2 style={{ marginTop: 40 }}>
                <CheckBox
                  type={"checkbox"}
                  checked={secret_yn}
                  readOnly
                  onClick={handleSecret_yn}
                />
                <div style={{ marginLeft: 5 }}>
                  <div>팔로우한 회원에게만 방송 보이기</div>
                  <div style={{ fontSize: 14, color: "red" }}>
                    *설정시 수정할 수 없습니다.
                  </div>
                </div>
              </RowView2>

              <RowView2 className="end" style={{ marginTop: 40 }}>
                <Btn
                  className={
                    livetime.some((item) => isUnableTime(item)) ||
                    livetime.length === 0 ||
                    live_title === "" ||
                    live_img === ""
                      ? ""
                      : "main"
                  }
                  onClick={create_live_API}
                >
                  라이브 예약하기
                </Btn>
              </RowView2>
            </div>
          </>
        )}
      </InsertArea>
      <input
        style={{ display: "none" }}
        ref={picPreviewRef}
        type="file"
        onChange={renderPic}
      />
      {livetime.length !== 0 && live_title !== "" && (
        <CoinPaymentModal
          visible={visible}
          handleModal={handleModal}
          livedate={livedate}
          live_start={new Date(make_date(livedate, livetime, "start"))}
          live_finish={new Date(make_date(livedate, livetime, "finish"))}
          live_title={live_title}
          live_img={live_img}
          live_limit={live_limit}
          secret_yn={secret_yn}
        />
      )}
    </Layout_Admin>
  );
};

export default LiveMake;

const InsertArea = styled(RowView)`
  div.box {
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
  @media ${({ theme }) => theme.mobile} {
    flex-direction: column;
    div.box {
      width: 100%;
    }
  }
`;
const ScrollBox = styled.div`
  box-sizing: border-box;
  width: 10.5rem;
  height: 40rem;
  padding: 1rem;
  padding-bottom: 0;
  margin-top: 1rem;
  border: 1px solid #f0f0f0;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 12px;
    background-color: #f0f0f0;
  }
  &::-webkit-scrollbar-thumb {
    background: #c6c6c6;
    &:hover {
      background: #ababab;
    }
  }
  @media ${({ theme }) => theme.mobile} {
    width: 100%;
    height: 6rem;
    display: flex;
    overflow-y: hidden;
    overflow-x: scroll;
    div {
      min-width: 7.5rem;
      height: 1rem;
      margin-bottom: 0;
      margin-right: 0.5rem;
    }
  }
`;
const ClickBox = styled.div`
  padding: 0.8rem 0rem;
  margin-bottom: 1rem;
  text-align: center;
  color: #8e8e8e;
  border: 1px solid #f0f0f0;
  border-radius: 50px;
  cursor: pointer;
  &.this {
    color: #ea2922;
    background-color: #ffe9e8;
    border-color: #ea2922;
  }
  &.unable {
    color: #bcbcbc;
    background-color: #f8f8f8;
    border: 1px solid #f8f8f8;
    cursor: default;
  }
`;
const InputBox = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 0.8rem;
  margin: 1rem 0rem;
  font-size: 16px;
  border: 1px solid #f0f0f0;
  outline: 0;
  border-radius: 8px;
  &:hover,
  &:focus {
    border: 1px solid #454545;
  }
`;
const Btn = styled.div`
  padding: 0.8rem 1.5rem;
  margin-bottom: 1rem;
  ${fontStyles.medium}
  font-size: 16px;
  border-radius: 4px;
  background: #eeeeee;
  color: #a5a5a5;
  &.main {
    color: white;
    background: linear-gradient(135deg, #7955f0, #3209b9);
    cursor: pointer;
  }
`;
const PicBox = styled(CenterView)`
  position: relative;
  width: 6rem;
  height: 6rem;
  margin: 1rem 0rem;
  color: #c6c6c6;
  font-size: 24px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;
